export class TreeUseractions {
    public static readonly GetTree = '11111111-2222-3333-4444-555555555555';
    public static readonly ItemMoveLeft = '601f7702-efcb-449e-a0e7-a208107f9ffe';
    public static readonly ItemMoveRight = '5788ee20-a764-4dc4-a878-553dd2e195aa';
    public static readonly ItemMoveUp = '10c52cd9-d522-4e5b-9b6c-bfff2c4830b0';
    public static readonly ItemMoveDown = '8a12806e-c3eb-4003-b31c-b309fc8ab18d';
    public static readonly ItemAdd = '99572e28-ec78-44de-835e-953ce1d6d5ed';
    public static readonly ItemRemove = '6c817186-344f-4edc-b2d2-bf1e6ef1f1e8';
    public static readonly TreeCreate = 'bf9bf4b1-b53c-41fe-a203-c39a5a99ac5b';
    public static readonly TreeRemove = '9b9f3502-61d2-4e69-b4e1-d2360a8501d1';
   
  }